import { render, staticRenderFns } from "./OtherColumnsAvailableTableHelper.vue?vue&type=template&id=2c0ffb34&scoped=true&"
import script from "./OtherColumnsAvailableTableHelper.vue?vue&type=script&lang=js&"
export * from "./OtherColumnsAvailableTableHelper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0ffb34",
  null
  
)

export default component.exports